import { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const DISMISS_KEY = 'ui_password_hint_dismissed'

type PasswordHintBannerProps = {
  className?: string
}

/** Shown when the backend reports no usable password (e.g. magic-link signup). */
export function PasswordHintBanner({ className }: PasswordHintBannerProps) {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1')

  const dismiss = useCallback(() => {
    sessionStorage.setItem(DISMISS_KEY, '1')
    setDismissed(true)
  }, [])

  if (dismissed) return null

  return (
    <div
      role="status"
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 text-sm text-foreground',
        className,
      )}
    >
      <p className="min-w-0 flex-1">
        Add a password to sign in without email links.{' '}
        <Link to="/auth/reset-password" className="underline underline-offset-4 hover:text-primary">
          Set or reset password
        </Link>
      </p>
      <Button type="button" variant="ghost" size="iconSm" onClick={dismiss} aria-label="Dismiss">
        <X className="h-4 w-4" />
      </Button>
    </div>
  )
}
